export const USER_INFO = 'user/userInfo';
